import React, {useEffect} from 'react';

import AppLoaderRaw from '@/components/Loader/AppLoader/AppLoaderRaw';
import queryParameters from '@/consts/route/queryParameters';
import * as sourceTypes from '@/consts/sourceTypes';
import useNotificationDetails from '@/hooks/inbox/useNotificationDetails';
import amplitudeInboxTracking from '@/services/analytics/amplitude/amplitudeInboxTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appRouterService from '@/services/route/appRouterService';
import urlUtils from '@/utils/urlUtils';

import NotificationDetails from './NotificationDetails';

const NotificationDetailsPage = ({messageId}) => {
    const onBackButtonClick = () => {
        appRouterService.forwardToInboxPage();
    };

    const {nextMessage, message, isLoaderActive, notFound} = useNotificationDetails({
        messageId,
    });

    useEffect(() => {
        if (message) {
            const [source] = urlUtils.getDataFromUrl(queryParameters.SOURCE) || sourceTypes.INBOX;

            amplitudeInboxTracking.trackNotificationDetailedScreen(source, message.campaignName);
            googleAnalyticsService.trackInboxDetailsScreenView(source, message.campaignName);
        }
    }, [message]);

    useEffect(() => {
        if (notFound) {
            appRouterService.forwardToInboxPage();
        }
    }, [notFound]);

    return (
        <>
            {isLoaderActive || !message ? (
                <AppLoaderRaw />
            ) : (
                <NotificationDetails
                    message={message}
                    nextMessage={nextMessage}
                    onBackButtonClick={onBackButtonClick}
                />
            )}
        </>
    );
};

export default NotificationDetailsPage;
